export default {
  myClasses: 'Mis Clases',
  myGrades: 'Mis Notas',
  goToPDATeacher: 'Ir al PDA Docente',
  goToPAStudent: 'Ir al PA Estudiante',
  teachers: 'Docentes',
  teacher: 'Docente',
  options: 'Menú',
  notesOf: 'Notas de la {entity}',
  assessmentPerStudent: 'Assessment por Estudiante',
  assessment: 'Assessment',
  evaluationsOf: '{entity1} de la {entity2}',
  assessmentReport: 'Reporte Assessment',
  progressionOf: 'Progresión de las {entity}',
  noDataToShow: 'No hay {entity} para mostrar',
  noClassesInPeriod: 'No hay clases cursadas en este {entity}',
  moduleNotEnabled: 'Este módulo no está habilitado para su institución',
  filterBy: 'Filtrar por {entity}',
  next: 'Próximas {entity}',
  visibleForEvaluatees: 'Visible para Evaluados',
  goToThe: 'Ir a la {entity}',
  inProgress: '{entity} en curso',
  noNext: 'No hay próximas {entity}',
  finished: '{entity} Terminadas',
  noEntity: 'No hay {entity}',
  toCorrect: '{entity} a Corregir',
  type: 'Tipo',
  state: 'Estado',
  goToCorrect: 'Ir a corregir la {entity}',
  entityOfEntity: '{entity1} del {entity2}',
  studentsNotStarted: 'Estudiantes que no han iniciado la {entity}',
  studentsStartedNotFinished: 'Estudiantes que comenzaron la {entity} pero no la finalizaron',
  studentsDoing: 'Estudiantes realizando la {entity}',
  studentsFinished: 'Estudiantes que terminaron la {entity}',
  studentsPublishedGrade: 'Estudiantes que ya se le publicó la nota',
  totalStudents: 'Total de estudiantes',
  noEntityToCorrect: 'No hay {entity} por corregir',
  allEvaluationsCorrected: 'No hay {entity} por corregir ',
  pastClasses: 'Clases ya cursadas',
  goToEntityProgram: 'Ir al {entity}',
  entityOfEntity2: '{entity1} de la {entity2}',
  noEntityToShow: 'No hay {entity} para mostrar',
  evaluationsInNext7Days: 'Evaluaciones en los Próximos 7 Días',
  noEvaluationsAssignedLast7Days: 'No tiene evaluaciones asignadas dentro de los últimos 7 días.',
  myEntity: 'Mis {entity}',
  noEntityAssignedCurrentPeriod: 'No cuenta con ninguna {entity} asignada en el periodo actual.',
  coursesWhereYouAreStudent: 'Cursos en los que eres estudiante:',
  coursesWhereYouAreProfessor: 'Cursos en los que eres docente:',
  level: 'Nivel',
  evaluations: 'Evaluaciones',
  gradingCenter: 'Centro de Calificaciones',
  notes: 'Notas',
  assessmentReport2: 'Reporte de Assessment',
  hide: 'Ocultar',
  show: 'Mostrar',
  current: 'Actuales:',
  completed: 'Completadas:',
  averageGradesCurrentPeriod: 'Promedio de notas del periodo actual',
  averageGradesCompletedEntity: 'Promedio de notas de {entity} cursadas',
  achievements: 'Logros',
  progressionOfEntity: 'Progresión de {entity}',
  entityCompleted: '{entity} Cursadas',
  noEntityCompleted: 'No cuenta con ninguna {entity} cursada.',
  coursesWhereYouWereStudent: 'Cursos en los que fuiste estudiante:',
  coursesWhereYouWereProfessor: 'Cursos en los que fuiste docente:',
  attentionNotifications: 'Atención/Notificaciones',
  has: 'Tiene',
  withoutDate: 'sin fechas asignada.',
  noNotifications: 'No tiene notificaciones...',
  assignDatesToRemainingEntities: 'Asignar fechas a las {entity} restantes',
  editDates: 'Editar Fechas',
  editStartAndEndDate: 'Editar Fecha de Inicio y Fecha de Término',
  announcements: 'Anuncios',
  noAnnouncementsLast7Days: 'Ningún anuncio de la institución en los últimos 7 días.',
  messages: 'Mensajes',
  noMessagesLast7Days: 'Ningún mensaje en los últimos 7 días.',
  resources: 'Recursos',
  noAssignedResources: 'No cuenta con recursos asignados.',
  evaluationHistory: 'Historial de Evaluaciones {header}',
  note: 'Nota',
  evaluation: 'Evaluación',
  scoreObtained: 'Puntaje Obtenido',
  weighting: 'Ponderación',
  noteColumnDescription: 'En esta columna muestra la nota de la evaluación con respecto a la {entity}.',
  instrument: 'Instrumento',
  noteInstrumentColumnDescription: 'En esta columna muestra la nota del instrumento con respecto a la Evaluación.',
  weightingDescription: 'Esta ponderación muestra cuanto pondera esta evaluación con respecto a la {entity}.',
  weightingInstrumentDescription: 'Esta ponderación muestra cuanto pondera el instrumento con respecto a la evaluación.',
  maxScore: 'Puntaje máximo',
  noDataToDisplay: 'No hay datos que mostrar',
  currentParentheses: '( Actuales )',
  completedParentheses: '( Completadas )',
  achievementResultsReport: 'Informe de Resultados de Logros',
  ceMacro: 'CE Macro',
  statement: 'Enunciado',
  informationOfThe: 'Información de la {entity}',
  gradesRecordOfThe: 'Registro de Notas de la {entity}',
  downloadExcel: 'Descargar Excel con las notas',
  searchStudents: 'Buscar Estudiantes...',
  viewColumns: 'Visualizar columnas',
  student: 'Estudiante',
  finalGrade: 'Nota Final',
  pressToUpdateAutomaticScoreColumn: 'Presione aquí para actualizar a puntaje automático a todos en la columna.',
  pressToUpdateAutomaticScoreFinalGrade: 'Presione aquí para actualizar a puntaje automático a todos en la columna nota final.',
  goToEvaluation: 'Ir a la Evaluación',
  pressToPublishScore: 'Presione aquí para publicar el puntaje del {entity}.',
  pressToWithdrawScore: 'Presione aquí para retirar la publicación el puntaje del {entity}.',
  studentNotInEvaluatees: '{student} no se encuentra entre los usuarios que pueden contestar el {entity}.',
  useAutomaticScore: 'Utilizar Puntaje automático',
  noDataMatchesSearch: 'No hay datos que coincidan con su búsqueda.',
  symbologyMeanings: 'Simbología / Significados',
  saveGradeDescription: 'Guarda la nota ingresada del {entity} o Evaluación.',
  updateAutomaticScoreDescription: 'Actualiza el puntaje/nota al valor Automático.',
  publishScoreDescription: 'Publica el puntaje del {entity} seleccionado a los estudiantes.',
  withdrawPublicationDescription: 'Retira la publicación el puntaje del {entity} seleccionado a los estudiantes.',
  indicatesAutomaticScore: 'Indica que se está utilizando el puntaje o nota automática para {entity} o Evaluación.',
  indicatesStudentCannotAnswer: 'Indica que el estudiante no puede contestar el {entity}.',
  gradeMustBeBetween: 'La nota debe estar entre {min} y {max}',
  validation: 'Validación',
  instrumentPublished: '{entity} publicado.',
  updatingScoresOf: 'Actualizando los puntajes del {entity}...',
  problemUpdatingInstruments: 'Hubo un problema al actualizar los {entity}.',
  updatingEvaluationGrades: 'Actualizando las notas de la evaluación...',
  problemUpdatingGrades: 'Hubo un problema al actualizar las notas.',
  updatingFinalGradeOf: 'Actualizando la nota final de la {entity}...',
  problemUpdatingFinalGrade: 'Hubo un problema al actualizar la nota final.',
  gradeUpdated: 'Nota actualizada.',
  instrumentNotAnswered: 'Instrumento no contestado',
  automaticScore: 'Puntaje automático',
  automaticGrade: 'Nota automática',
  instrumentStartedOn: 'El instrumento se inicio el {date}',
  scoreMustBeBetween: 'El puntaje debe estar entre {min} y {max}',
  noPermissionToViewNextView: 'No tienes permiso para ver la siguiente vista',
  teacherName: 'Nombre del Docente',
  studentAttentionSchedule: 'Horario de Atención al Estudiante',
  coexistenceRulesForThe: 'Normas de Convivencia para la',
  filterGradesByPeriod: 'Filtrar notas por periodo:',
  currentPeriods: 'Periodos Actuales',
  weightedGrade: 'Nota Ponderada',
  feedback: 'Retroalimentación',
  feedbackAbbreviation: 'R...',
  gradeOfThe: 'Nota de la {entity}',
  finalGradeOfThe: 'Nota final de la {entity}',
  weightingOfThe: 'Ponderación del {entity}',
  totalScoreOfThe: 'Puntaje total del {entity}',
  feedbackOfThe: 'Retroalimentación de la {entity}',
  evaluatorAttachment: 'Adjunto del Evaluador',
  noEvaluationFoundYet: 'No se ha encontrado ninguna evaluación aún.',
  welcomeToPlatformTitle: '¡Te damos la bienvenida, {name}!',
  welcomeToPlatformDescription: 'Nos alegra que seas parte de la plataforma. Ahora podrás acceder a la información académica y a las herramientas disponibles para tu perfil.',
  welcomeToPlatformHint: 'Desde el menú lateral de la izquierda podrás acceder a la distinta información y secciones disponibles para ti.',
}